module.exports = __webpack_public_path__ + "static/media/sin-blue.f489e87d.svg";